module.exports = __webpack_public_path__ + "img/ic_hukou.dfa6f95c.png";